(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){
const opener=e.target.closest('[data-hsl-size-open]');
if(opener){const modal=opener.nextElementSibling;if(modal && modal.tagName==='DIALOG' && !modal.open){modal.showModal();}return;}
const closer=e.target.closest('[data-hsl-size-close]');
if(closer){closer.closest('dialog').close();return;}
if(e.target.matches('.hsl-size-dialog')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}
});
  } catch(e) { console.error(e); }
})();

})();
